import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

// Report web subscriptions module configurations
export const LISTING_COLUMNS = [
  {
    id: 'subscriberName',
    label: 'Subscriber Name',
    width: '20%',
    align: 'left',
    dataKey: 'subscriberName',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'channelName',
    label: 'Channel',
    width: '20%',
    align: 'left  ',
    dataKey: 'channelName',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'tierLabel',
    label: 'Tier',
    width: '10%',
    align: 'left',
    dataKey: 'tierLabel',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'startedAt',
    label: 'Start Date',
    width: '20%',
    align: 'right',
    dataKey: 'startedAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'endedAt',
    label: 'End Date',
    width: '20%',
    align: 'right',
    dataKey: 'endedAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  },
];

export const VIEW_COLUMNS = [
  {
    id: 'subscriberName',
    label: 'Subscriber Name',
    dataKey: 'subscriberName',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'channelName',
    label: 'Channel',
    dataKey: 'channelName',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'tierLabel',
    label: 'Tier',
    dataKey: 'tierLabel',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'startedAt',
    label: 'Subscription Start Date',
    dataKey: 'startedAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'endedAt',
    label: 'Subscription End Date',
    dataKey: 'endedAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];
